"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarMenuCollapse = void 0;
var react_1 = __importDefault(require("react"));
var SidebarMenuCollapse = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: className,
    width: "24",
    height: "13",
    viewBox: "0 0 24 13"
  }, react_1.default.createElement("path", {
    d: "M23.5 1H8.5C8.2 1 8 0.8 8 0.5C8 0.2 8.2 0 8.5 0H23.5C23.8 0 24 0.2 24 0.5C24 0.8 23.8 1 23.5 1Z"
  }), react_1.default.createElement("path", {
    d: "M23.5 7H8.5C8.2 7 8 6.8 8 6.5C8 6.2 8.2 6 8.5 6H23.5C23.8 6 24 6.2 24 6.5C24 6.8 23.8 7 23.5 7Z"
  }), react_1.default.createElement("path", {
    d: "M23.5 13H8.5C8.2 13 8 12.8 8 12.5C8 12.2 8.2 12 8.5 12H23.5C23.8 12 24 12.2 24 12.5C24 12.8 23.8 13 23.5 13Z"
  }), react_1.default.createElement("path", {
    d: "M3.70235 10.4002C3.55225 10.4002 3.45219 10.3502 3.35212 10.2502L0 6.50017L3.35212 2.60017C3.55225 2.40017 3.85244 2.35017 4.05257 2.55017C4.2527 2.75017 4.30273 3.05017 4.1026 3.25017L1.30082 6.50017L4.05257 9.60017C4.2527 9.80017 4.20266 10.1002 4.00254 10.3002C3.9525 10.3502 3.85244 10.4002 3.70235 10.4002Z"
  }));
};
exports.SidebarMenuCollapse = SidebarMenuCollapse;